export default "__VITE_ASSET__BcCCd0s3__"